import React, { useEffect, useState} from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils';
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from '../../components/tab';
import ResourcesTable from './allResources';
import {
  TabStripSelectEventArguments,
} from "@progress/kendo-react-layout";
import { getAllocatedto, getFilteredCandidates, getCandidates , getProviderResources , getRecruiterResources } from './services'
import { addFilter } from '../../utils/filterNew'
import { viewedpageMixpanel } from '../../utils/mixpanel';




function CRResourcesTab() {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2)
  let BreadcrumsValues = ['Resources']
  localStorage.removeItem('candidateLoginId')
  const userloginId = localStorage.getItem("loginId");
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [verifiedTotal, setVerifiedTotal] = useState<number>()
  const [verified, setVerified] = useState<any>()
  const [CRresourceData, setCRresourceData] = useState<any>([])
  const [CRresourceCount, setCRresourceCount] = useState<string>('')
  const [myDraft, setMyDraft] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [filterValues, setFilterValues] = useState<any>(null);
  const [search, setSearch] = useState<string>('');
  const [sort, setSort] = useState<any>([]);
  const [behalf_of, setBehalf_of] = useState<any>()

  const [date, setDate] = useState<any>()
  let cr = localStorage.getItem('role');
 
 
  useEffect(() => {

    getResources('crowdSourcingAll', 1, 25,'', '', '')
    viewedpageMixpanel();
    getAllocation();
    // localStorage.setItem('candidateLoginId','');

  }, [])

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelectedTab(e.selected)
    
  }

  const getAllocation = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  const searchChange = (e: string) => {

    setSearch(e)
    getResources( 0, 25, 1, e, filterValues,sort)
  }

  const getResources = (tabValue: any, pageSize: number, pageNumber: number, searchValue: string, filter?: any,sort?:any) => {
    let tabName = "crowdSourcingAll"
    let value: any = {filters: { }}
    getCandidates(pageNumber, pageSize, tabName, search, value).then((response) => {
      if (response && response.status === 1) {
        setCRresourceData(response.data)
        setCRresourceCount(response.count)
      }
    })
  }

  const getResourceTables = () => {

    getResources( 0, 25, 1, search)
 }
 
 const VerifiedTab = <>All resources<i>{CRresourceCount}</i></>
 
 const pageChange = (pageSize: number, pageNumber: number) => {

  let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1; 
  getResources( selectedTab, pageSize, page, search, filterValues,sort )
  
  }
  const applyFilter = (data: any) => {
    
    setBehalf_of(data.filters.behalf_of)
    getResources(0, 25, 1, search, data,sort)
    
    delete data.coreSkillsCombination
    delete data.positionStatusCombination
    data.filters.behalf_of = data.filters.behalf_of !== undefined ? data.filters.behalf_of.name : undefined 
    setFilterValues(data.filters)
  }

  const closeTag = (data: any) => {
  
    if(data.behalf_of){
      if(behalf_of !== undefined){
        data.behalf_of = behalf_of
      }
    }
    let value = {
      filters: data
    }
    applyFilter(value)  
  }

  const applySort = (sort: any) => {
    getResources(0, 25, 1, search, filterValues , sort)
    getResources(1, 25, 1, search, filterValues , sort)
    getResources(2, 25, 1, search, filterValues , sort)
    getResources(3, 25, 1, search, filterValues , sort)
    getResources(4, 25, 1, search, filterValues , sort)
    getResources(5, 25, 1, search, filterValues , sort)
  };

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={'crresource'} />
      <div className="dashboardContent">
        <DashboardHeader title={BreadcrumsValues}  allocatedTo={allocatedTo} navigateTo={cr === 'CR-RECRUITER' ? '/CRcreateresources' : '../createResources'} type='resources' searchChange={searchChange} applyResourceFilter={applyFilter} filterValues={filterValues} closeTag={closeTag}  getProviderResources={ getProviderResources} getRecruiterResources={getRecruiterResources} behalf_of={behalf_of}/>
        <div className={Styles.sourceFilter}>
        </div>
        <section className={Styles.dashboardWrapper}>
          <TabStrip selected={selectedTab} onSelect={handleSelect}>
              <Tab title={VerifiedTab} >
                  <ResourcesTable setSort={setSort} applySort={applySort} data={CRresourceData} getTablesValues={getResourceTables} total={CRresourceCount} pageSize={pageChange}/>
              </Tab>
          </TabStrip>
        </section>
      </div>
    </section>
  )
}

export default CRResourcesTab
